<template>
    <div class="row">
        <div class="col-12" v-for="(prompt,index) in userPrompts" :key="index">
            <prompt-container
                :prompt="prompt.prompt"
                :type="prompt.prompt.type"
                :prompt-id="prompt.prompt_id"
                :page-id="pageId"
                :key="prompt.prompt_id"
                :is-dark-bg="isDarkBg"
                :module-id="moduleId"
                :course-id="courseId"
                :course-name="courseName"
                :is-augmented="isAugmented"
                :is-mission="isMission"
                @updatePrompt="(data) => updatePrompt(data,index)"
            />
        </div>
    </div>
</template>

<script>
import PromptContainer from "./PromptContainer";

export default {
    name: "PromptGroup",
    components:{
        PromptContainer,
    },
    props:{
        header: Object,
        prompts: Array,
        pageId: String,
        moduleId: Number,
        courseId: Number,
        courseName: String,
        isAugmented: Boolean,
        isMission: String,
        isDarkBg: Boolean
    },
    data(){
        return {
            userPrompts: this.prompts
        }
    },
    methods:{
        updatePrompt(data, index){
            this.userPrompts[index].submission = data;
        }
    },
    computed:{
        groupLength(){
            return this.userPrompts.length;
        }
    }
}
</script>
